import { render, staticRenderFns } from "./FullScreenControl.vue?vue&type=template&id=389536c0&"
import script from "./FullScreenControl.vue?vue&type=script&lang=js&"
export * from "./FullScreenControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports